import { ShareNetworkIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

import { Button, MiterIcon } from "ui2";

export const SafetyProfileHeader = (): React.JSX.Element => {
  const copyLink = async (): Promise<void> => {
    await navigator.clipboard.writeText(window.location.href);
    toast.success("Copied link to this safety profile");
  };

  return (
    <header className="tw:flex tw:shrink-0 tw:items-center tw:gap-3 tw:border-b tw:border-stroke tw:bg-white tw:px-4 tw:py-2.5">
      <MiterIcon />
      <div className="tw:font-denim tw:text-lg tw:text-midnight">Safety Profile</div>
      <Button className="tw:ml-auto" size="icon" variant="ghost" aria-label="Share" onClick={copyLink}>
        <ShareNetworkIcon size={18} />
      </Button>
    </header>
  );
};
